import { TApplicationState } from '../../types/redux';

export const isAutorisationPopupOpenSelector = (state: TApplicationState) =>
  state.consultantCianChat.isAutorisationPopupOpened;
